module.exports = __webpack_public_path__ + "img/1562867266.9da41e4d.jpg";